import { createFileRoute } from '@tanstack/react-router'
import { CREATE_ACCESS } from '../../../app/access'
import { requireAccess } from '../../../app/guards'
import { taxRatesQueryOptions } from '../../../features/finance/queries'
import { NewCreditNotePage } from '../../../features/sales/credit-note-pages'
import { salesSettingsQueryOptions } from '../../../features/sales/queries'
import { newCreditNoteSearchSchema } from '../../../features/sales/search'

export const Route = createFileRoute('/_app/credit-notes/new')({
  staticData: { crumb: 'creditNoteNew' },
  validateSearch: newCreditNoteSearchSchema,
  beforeLoad: ({ context }) => requireAccess(context.session, CREATE_ACCESS.creditNote),
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(salesSettingsQueryOptions),
      context.queryClient.ensureQueryData(taxRatesQueryOptions),
    ])
  },
  component: NewCreditNotePage,
})
